import React, { useState, useEffect, useRef } from "react";
import { gsap, Power3 } from "gsap";
import {connect} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import blockStyles from './modules/accountblock/accountblock.module.css';
import styles from './app.accountPage.module.css';
import AccountBlock from './modules/accountblock';
import {ReactComponent as ArrowBack} from "../static/icons/arrow_back.svg";
import Config from "../Config.json"
import classNames from "classnames";
import Modal from './module.modal';
import Loader from "../static/svg/loader.svg";
import axios from "axios";
// import { utcToZonedTime, format, zonedTimeToUtc } from 'date-fns';

function Account(props) {
    const navigate = useNavigate();
    const ref = useRef(null);
    const [showLoader, setShowLoader] = useState(true);
    const [formError, setFormError] = useState();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [page, setPage] = useState(0);
    const [subscriber, setSubscriber] = useState({});
    const [userDetail, setUserDetail] = useState({
      firstName: "First",
      lastName: "Last",
      email: "Email"
    });
    // const history = useHistory();

    useEffect(() => {
      setShowLoader(false);
        gsap.to(ref.current,{duration:0.35,ease:Power3.easeInOut,opacity:1})
        console.log('props.showContSettings', props)

    }, []);

    useEffect(() => {
      console.log(props.user)

    //   if (props.user.org && props.user.org.subscription) {
    //     setSubscriber(props.user.org.subscription)
    //   }
    }, [props.user])

    function handleBackBtn(){
        navigate('/account/')

    }

    function deleteAccount() {
     
        let comment = {
            username:props.user.username,
            narrative:26,
            location:window.location.hash?window.location.hash.substring(1):window.location.pathname+window.location.search,
            comment:"delete user"
        }
        setLoading(true)
        console.log('comment', comment)
        // axios( {
        //     method: 'post',
        //     url:Globals.instance().adminAPI+'/api/user-comments-add/',
        //     data:comment
        // }).then(results=>{
            
        //     setSuccess(true);
            
            
        // }).catch(err=>{
        //     Globals.instance().showAlert('Could not add comment ',err)
        //     console.error(err)
        //     setLoading(false)
        // })
    }

    return (

         <section className={"mt-50 pt-50 greyBkg scrollY"} id="accountPage">
      {(showLoader)?(<div id="loading"><img src={Loader} alt="" /></div>):null}

      {(formError)&&<Modal heading={formError.heading} text={formError.text} onBtn1Click={setFormError} onBtn1={null} btn1Text={"Close"} onBtn2Click={null} onBtn2={null} btn2Text={null} />}


       {subscriber && <div className="appGrid">
      
            <div id="narrativeTools">
      
            
      
      
              </div>

                <div className="flexflexColumn justifyCenter">
      





                <div className="flex alignCenter flexColumn">
        
                    <span className="justifyCenter flex flexColumn alignCenter">
                    <h1>Account Info</h1>

                        <div className="ui expo-pill-btn" onClick={() => handleBackBtn()}>
                        Back to Settings
                        </div>

                        <nav className="subNav">
                        <ul className="navLinks">
                            <li className={classNames("navLink", { on: page === 0 })}><span onClick={() => setPage(0)}>General</span></li>
                            <li className={classNames("navLink", { on: page === 1 })} style={{display: "none"}}><span onClick={() => setPage(1)}>License</span></li>
                            <li style={{display: "none"}} className={classNames("navLink", { on: page === 2 })}><span onClick={() => setPage(2)}>Payments</span></li>
                        </ul>
                        </nav>
                    </span>

            
                    <div className="flex flexColumn" style={{width:'100%'}}>

                    {page === 0 && <div className="flex flexColumn alignCenter" id="settingsPage0">

                            {props.user && 
                                <span style={{marginBottom: 60, maxWidth: 800, width: '100%'}}><AccountBlock 
                                icon={props.user && props.user.username ?<span className={blockStyles.accountBlockAvatar}>{props.user.username.charAt(0)}</span>:null}
                                heading={props.user?props.user.username:""}
                                text={null}
                                cta={null}
                                link={'/account/reset-password/'}
                                target={null}
                                orientation={"horizontal"}
                                background={"#2B2B2B"}
                            ></AccountBlock></span>
                            }

                            {userDetail &&
                                <div className={`${blockStyles.row} greyBkg2`}>
                                <span className={`${styles.mainCol}`}>
                                <h2>Personal Information</h2>
                                <span><h3>Name</h3><p>{userDetail.firstName + " " + userDetail.lastName}</p></span>
                                <span><h3>Email</h3><p>{userDetail.email}</p></span>
                                </span>
                                </div>
                            }


                            {props.user && props.user.org &&
                                <div className={`${blockStyles.row} greyBkg`}>
                                <span className={`${styles.mainCol}`}>
                                <h2>Permissions</h2>
                                {props.user.org && <span><h3>Organization</h3><p>{props.user.org.name}</p></span>}
                                {props.user && <span><h3>User Role</h3><p style={{textTransform: "capitalize"}}>{props.user.type}</p></span>}
                                </span>
                                </div>
                            }

                                <div className={`${blockStyles.row} greyBkg2`} style={{marginBottom: 0}}>
                                <span className={`${styles.mainCol}`}>
                                <h2>Request Account Deletion</h2>
                                <p>Submit a request to delete your account. We will confirm this request and then delete your account. Account deletion will purge the system of all account data. We will email you when that process is complete.</p>
                            
                                <span style={{marginTop: 40}}>{(success)?(<h4>Request successfully submitted</h4>): ((!loading)?<div onClick={deleteAccount} style={{paddingTop: '10px'}} className="expo-pill-btn">Submit Request</div>:"Sending ...")}</span>
                                </span>
                                </div>

                            
                        
                    </div>}
                    {page === 1 && <div className="flex flexColumn" id="settingsPage1">

                    {subscriber &&
                                <div className={`${blockStyles.row} greyBkg`}>
                                <span className={`${styles.mainCol}`}>
                                <h2>Term</h2>
                                <span><h3>Name</h3><p>{userDetail.firstName + " " + userDetail.lastName}</p></span>
                                <span><h3>Email</h3><p>{userDetail.email}</p></span>
                                </span>
                                </div>
                            }
                    
                            {subscriber &&
                                <div className={`${blockStyles.row} greyBkg2`}>
                                <span className={`${styles.mainCol}`}>
                                <h2>License</h2>
                                <span><h3>Subscription</h3><p>{subscriber.name}, {subscriber.user_count > 0 ? (subscriber.user_count + " Users") : (subscriber.user_count + " User")}</p></span>
                                <span><h3>Renews</h3><p></p></span>
                        
                                </span>
                                </div>
                            }

                    </div>}
                    {page === 2 && <div className="flex flexColumn" id="settingsPage2">

                    </div>}

                    </div>     
                    
                    

                        </div>
                
                
             </div>
    
        </div>}
    
    
    </section>
    );
}


export default Account;


// <a href="/reset-password/" className="reset">Reset Password</a>

    //  {subscriber.renews && format(new Date(zonedTimeToUtc(subscriber.renews, Intl.DateTimeFormat().resolvedOptions().timeZone)), "MMM d, Y")}

          //  <span><h3>Your Token</h3><p>{props.user && props.user.token}</p></span>